<template>
  <v-dialog
    :value="visiblePopup"
    :max-width="330"
    @click:outside="onNoClickButton"
    @keydown.esc="onNoClickButton"
  >
    <v-card class="popup-wrapper">
      <div class='title-section'>
        <div class='warning-icon'>
          <img :src='warningIcon'>
        </div>
        <div class="title">{{$t('delete.tld.popup.title')}}</div>
      </div>
      <div class='message-section'>
        <span class="message">{{messageFirstPart}}</span>
        <span class="tld">{{ tld }}</span>
        <span class="message">{{messageSecondPart}}</span>
      </div>
      <div class="buttons">
        <v-btn small depressed class="no-button btn-secondary" @click="onNoClickButton()" :disabled='deleteConfigurationLoading'>
          {{$t("confirm.cancel")}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :loading='deleteConfigurationLoading'>
          {{$t("confirm.ok")}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import warningIcon from '@/assets/icons/warning_icn@1x.svg';
import { mapGetters } from 'vuex';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'DeleteDomainPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    tld: {
      required: true,
      type: String,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['deleteConfigurationLoading']),
    messageFirstPart() {
      return `${this.$t('delete.tld.popup.message.part.1')}`;
    },
    messageSecondPart() {
      return `${this.$t('delete.tld.popup.message.part.2')}`;
    },
    warningIcon() {
      return warningIcon;
    },
  },
  watch: {
    deleteConfigurationLoading() {
      if (!this.deleteConfigurationLoading) {
        this.closePopup();
      }
    },
  },
  methods: {
    async onYesClickButton() {
      this.$emit('deleteTld');
    },
    onNoClickButton() {
      this.closePopup();
    },
    closePopup() {
      if (!this.deleteConfigurationLoading) {
        this.$emit('closed');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  max-width: rem(380);
  padding: $space-8 $space-10;
  .title-section {
    display: flex;
    .title {
      color: var(--text-primary);
      font-size: $font-size-base;
      font-weight: 600;
      letter-spacing: 1.12px;
      line-height: $space-4;
      text-transform: uppercase;
      padding-bottom: rem(23);
      margin-left: rem(7);
      margin-top: $space-0-5;
    }
  }
  .message {
    font-size: $font-size-base;
    line-height: 1.36;
    font-weight: normal;
    color: var(--text-primary);
    letter-spacing: 0;
    line-height: rem(18);
  }
  .tld {
    color: var(--text-primary);
    font-size: $font-size-base;
    font-family: $font-family-medium;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: rem(18);
  }

  .buttons {
    text-align: right;
    padding-top: rem(30);

    .no-button {
      height: $space-8;
      border-radius: $radius-sm;
    }

    .yes-button {
      height: $space-8;
      border-radius: $radius-sm;
      margin-left: $space-2;

      ::v-deep .v-btn__loader .v-progress-circular svg circle {
        stroke: var(--text-inverse);
      }
    }
  }
}
</style>
